import {Button, DatePicker, message, Modal, Popconfirm, Select, Spin, Table, Tooltip} from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';

import { Row,Col,Form, Input, InputNumber } from "antd";
import {
} from '../../axios/dictionaries';
import {config, post, postFrom} from '../../axios';
import {
    API_CHECKLIST,
    API_device_findList, API_GETDEVICEBILLWRITEOFFBYID, API_GETHOUSEDEVICEBILLBYID, API_HOUSEDEVICEINVENTORYBYID,
    API_salesroom_findList
} from '../../axios/config';
import moment from "moment";
import FileUpload from "../../components/FileUpload";
import {formatTime} from "../../utils";
import TextArea from "antd/lib/input/TextArea";

class DeviceDetail extends React.Component{
    state = {
        id: null,
        checkRoomInId:null,
        visible: false,
        dataInfo: {},
        salesroomList: [],
        deviceList:[],
        dataLoading: false,
        submitLoading: false,
        data: {
            otherExpensesConfirmList:[]
        }
    }
    open(id = null) {
        if (id) {
            this.postHouseTypeGet(id)
        }
        this.postDeviceList();
        this.postSalesroomList()
        this.setState({ visible: true, id })
        return new Promise((resolve,reject) => {
            this.monitor = { resolve, reject }
        })
    }


    close() {
        this.setState({ visible: false ,data: {}})
        this.props.form.resetFields()
    }
    renderFooter() {
        return (
            <div className="app-modal-footer">
                <Button onClick={this.close.bind(this)}>取消</Button>
            </div>
        )
    }
    postSalesroomList() {
        post({ url: API_salesroom_findList }).then(res =>{
            this.setState({ salesroomList: res })
        })
    }
    postDeviceList() {
        post({ url: API_device_findList }).then(res =>{
            this.setState({ deviceList: res })
        })
    }
    postHouseTypeSubmit(data) {
        const url =  API_CHECKLIST+ '?houseId=' + this.state.id
        this.setState({ submitLoading: true })

        return post({ url, data }).then(res => {
            // this.setState({ submitLoading: false })
        }).finally(err => {
            this.setState({ submitLoading: false })
        })
    }
    postHouseTypeGet(id) {
        this.setState({ dataLoading: true })
        post({ url: API_GETDEVICEBILLWRITEOFFBYID + '?writeOffId=' + id  }).then(res => {
            const data = {
                projectName: res.projectName,
                cycleDate: res.cycleDate,
                registrationDate: res.registrationDate,
                transferMoney: res.transferMoney,
                transferDate: res.transferDate,
                approvalRemark: res.approvalRemark
            }
            res.otherExpensesConfirmList = res.billList
            if(res.attachVoList){
                this.fileUploadRef.setFileToState(res.attachVoList)
            }
            this.props.form.setFieldsValue(data)
            this.setState({ data: res,dataLoading: false })
        }).catch(err => {
            this.setState({ dataLoading: false });
        })
    }
    handleSubmit() {
        this.props.form.validateFields((err, values) => {
            if (err) return
            values.id = this.state.id || undefined

            //根据房源Id提交核对清单


            this.postHouseTypeSubmit(values).then(() => {
                this.close()
                this.monitor.resolve()
                message.success('保存成功')
            }).catch((e) => {
                message.error(e.message)
            })
        })
    }
    render(){
        const modalConfig = {
            title: '账单明细',
            visible: this.state.visible,
            footer: this.renderFooter(),
            width: 1200,
            onCancel: () => this.close()
        }
        const otherExpensesConfirmColumns = [
            {
                title: '房源编号',
                dataIndex: 'houseNo',
                fixed: 'left'
            },
            {
                title: '房号',
                dataIndex: 'roomNo'
            },
            {
                title: '账单周期',
                dataIndex: 'cycleDate'
                ,render: text => formatTime(text, 'YYYY-MM')
            },
            {
                title: '账单金额',
                dataIndex: 'rent'
            }
        ]
        let {
            data,
        } = this.state;
        const { getFieldDecorator, getFieldValue } = this.props.form
        const labelWidth = 70
        const labelValue = getFieldValue('label')
        return (
            <Modal {...modalConfig}>
                <Spin spinning={this.state.dataLoading}>
                    <div className="custom" style={{padding: 20}}>
                        <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
                            <Row>
                                <Col span={24}>
                                    <CustomRow >
                                        <CustomCol label="转账日期">
                                            {getFieldDecorator('transferDate', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                                initialValue: moment()
                                            })(
                                                <Input
                                                    placeholder={'请输入'}
                                                    min={0}
                                                    formatter={value => value !== '' ? value : 0}
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol label="转账金额" subfix={<div>元</div>} subfixRight={30}>
                                            {getFieldDecorator('transferMoney', {
                                                initialValue: 0,
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }]
                                            })(
                                                <InputNumber
                                                    placeholder={'请输入'}
                                                    min={0}
                                                    formatter={value => value !== '' ? value : 0}
                                                />
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol  label="核销项目">
                                            {getFieldDecorator('projectName', {
                                                rules: [{
                                                    required: true, message: '请选择项目',
                                                }],
                                            })(
                                                <Input
                                                    placeholder={'请输入'}
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol  label="账单周期">
                                            {getFieldDecorator('cycleDate', {
                                                rules: [{
                                                    required: true, message: '账单周期',
                                                }],
                                            })(
                                                <Input
                                                    placeholder={'请输入'}
                                                />
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol  label="验收日期">
                                            {getFieldDecorator('registrationDate', {
                                                rules: [{
                                                    required: true, message: '验收日期',
                                                }],
                                            })(
                                                <Input
                                                    placeholder={'请输入'}
                                                />
                                            )}
                                        </CustomCol>
                                </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol label="备注信息" colStyle={{ width: '500px', height: '100px' }}>
                                            {getFieldDecorator('approvalRemark', {
                                                initialValue: 0,
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }]
                                            })(
                                                <TextArea
                                                    rows={3}
                                                    cols={10}
                                                    placeholder={'请输入'}
                                                    style={{ height: '100px' }}
                                                    autoComplete={'off'}
                                                />
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <DetailTitle title="转账回执" />
                                    <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="deviceBillWriteOff"  fileTypeList={[17]} isValueStyle={true}/>

                                    <DetailTitle title="账单明细列表"  />
                                    <Table
                                        columns={otherExpensesConfirmColumns}
                                        dataSource={data.otherExpensesConfirmList}
                                        scroll={{x: 900}}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Spin>
            </Modal>
        )

    }
    handleMinus = (index) => { //房源户型减1
        let { data } = this.state;
        let item = data.houseLayout[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_category_device_deleteDeviceLayout, data: { houseLayoutId: item.id } }).then(res => {
                    data.houseLayout.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.houseLayout.splice(index, 1);
                this.setState({ data });
            }
        }
    }

    handlePlus = () => { //房源户型加1
        let { data } = this.state;
        if (data.houseLayout instanceof Array) {
            if (data.houseLayout.length) {
                data.houseLayout.push({ key: data.houseLayout[data.houseLayout.length - 1].key + 1, f: '', t: '', });
            } else {
                data.houseLayout.push({ key: 0, f: '', t: '' });
            }
        } else {
            data.houseLayout = [{ key: 0, f: '', t: '' }];
        }
        this.setState({ data });
    }
    handleChoose = () => {
        if (this.chooseRef) {
            this.chooseRef.onShow(this.state.data.checkRoomInId).then(res => {
                console.log('222');
                this.postHouseTypeGet(this.state.id);
            }).catch(() => {})
        }
    }
    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, title: "房源设备账单明细" });
    }
}



export default Form.create({ wrappedComponentRef: true })(DeviceDetail)


// WEBPACK FOOTER //
// ./src/page/DeviceBillWriteOff/deviceDetail.jsx